import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAccessAllowed } from "../../../auth";
import APIComponent from "../../../components/API";
import core from "../../../vendors/core-api";
import ReservationsSettingsDiv from "../../../partials/ReservationsSettingsDiv";
import StoreInfoManager from "../../../partials/StoreInfoManager";
import ReservationsConsole from "./ReservationsConsole";
import { HeaderTextWithActions } from "../../../components/Base";
import { PRIMARY_COLOR, RESERVATION_COLOR } from "../../../constants";
import { isReservationV2Enabled } from "../../../helpers/featureFlags";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { Tabs, Tab } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

export default function Page() {
  const params = useParams(),
    { user } = useSelector((state) => state.auth),
    { store_id = "" } = params;

  return isAccessAllowed(user, { store_id }) ? (
    <ReservationsHome id={store_id} />
  ) : (
    <Redirect to={"/error/error-v3"} />
  );
}

class ReservationsHome extends APIComponent {
  constructor(props) {
    super(props);
    const store_id = this.props.id;
    this.state = {
      store_id,
      store: null,
      data_status: "initial",
      isAsideMinimized: document.body.classList.contains("aside-minimize"),
    };

    this.data_url = `/store/${store_id}`;
    this.api = core("pu").get();
    this.updateStoreInfo = this.updateStoreInfo.bind(this);
  }

  handleOnDataFetched = () => {
    const { data = {} } = this.state;
    this.setState({
      store: data,
    });
  };

  updateStoreInfo = (values, setSubmitting) => {
    const { _id = {} } = this.state.store;
    this.api
      .put({
        url: "/store/" + _id,
        data: values,
      })
      .then(() => {
        MySwal.fire({
          icon: "success",
          title: "Success!",
          text: "You have successfully saved your changes.",
          confirmButtonColor: PRIMARY_COLOR,
          confirmButtonText: "Ok",
          timer: 1000,
        });
      })
      .catch(() => {
        this.handleError();
      })
      .finally(() => setSubmitting(false));
  };

  async componentDidMount() {
    this._isMounted = true;
    await this.getData();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const isMinimized =
            document.body.classList.contains("aside-minimize");
          if (this.state.isAsideMinimized !== isMinimized) {
            this.setState({ isAsideMinimized: isMinimized });
          }
        }
      });
    });

    observer.observe(document.body, { attributes: true });
    this.observer = observer;
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  render() {
    const { store, data_status, store_id, isAsideMinimized } = this.state;

    if (data_status !== "fetched" || !store) {
      return null; // Or a loading spinner
    }

    return (
      <div className="reservations-home-fluid">
        <style>
          {`          
          /* --- Full-width styles for ReservationsHome --- */
          .reservations-home-fluid {
            width: ${
              isAsideMinimized ? "calc(100vw - 90px)" : "calc(100vw - 180px)"
            };
            position: relative;
            left: 50%;
            right: 50%;
            margin-left: -50vw;
            margin-right: -50vw;
            padding-left: ${isAsideMinimized ? "5vw" : "200px"};
            padding-right: 25px;
          }

          /* --- Responsive styles for mobile --- */
          @media (max-width: 991.98px) {
            .reservations-home-fluid {
              width: auto;
              position: static;
              left: auto;
              right: auto;
              margin: 0;
              padding: 0;
            }
          }
          /* --- Tab styles --- */
          .reservations-home-fluid .purple-tabs .nav-link {
            color: #464E5F; /* Default tab text color */
          }
          .reservations-home-fluid .purple-tabs .nav-link.active, 
          .reservations-home-fluid .purple-tabs .nav-item.show .nav-link {
            color: ${RESERVATION_COLOR}; /* Active tab text color */
            border-color: #dee2e6 #dee2e6 #fff; /* Standard border colors */
            border-bottom: 3px solid ${RESERVATION_COLOR}; /* Active tab bottom border */
          }
          .reservations-home-fluid .purple-tabs .nav-link:not(.active):hover {
            color: ${RESERVATION_COLOR}; /* Hover color for inactive tabs */
          }
          .reservations-home-fluid .purple-tabs .nav-link.active:hover {
            color: ${RESERVATION_COLOR}; /* Hover color for active tab */
          }
          .reservations-home-fluid .tab-content {
            background-color: unset;
          }
          `}
        </style>
        <>
          <HeaderTextWithActions
            breadcrumbs={
              <Breadcrumbs>
                <Breadcrumbs.Item text={store.brand.name} link={`/`} />
                <Breadcrumbs.Item text="Reservations" link={`/reservations`} />
                <Breadcrumbs.Item
                  text={store.name}
                  link={`/stores/${store_id}/reservations/home`}
                  active
                />
              </Breadcrumbs>
            }
            title={
              <span className="d-inline-flex align-items-center">
                Reservations Home
                {isReservationV2Enabled() && (
                  <span
                    className="badge badge-pill badge-light-primary ml-2 font-weight-boldest"
                    style={{
                      fontSize: "0.75rem",
                      letterSpacing: "0.5px",
                      padding: "0.25rem 0.55rem",
                    }}
                    title="Reservation Engine v2"
                  >
                    v2
                  </span>
                )}
              </span>
            }
            subtitle={<></>}
          />
          <Tabs
            defaultActiveKey="console"
            id="reservations-home-tabs"
            className="mb-3 purple-tabs"
          >
            <Tab eventKey="console" title="Reservations Console">
              <ReservationsConsole id={store_id} isEmbedded={true} />
            </Tab>
            <Tab eventKey="settings" title="Experience Settings">
              <ReservationsSettingsDiv store={store} />
            </Tab>
            <Tab eventKey="store-info" title="Store Information">
              <StoreInfoManager store={store} onSubmit={this.updateStoreInfo} />
            </Tab>
          </Tabs>
        </>
      </div>
    );
  }
}
